<template>
  <select-input :value="value"
                @input="input"
                :options="factories"
                label="name"
                :label-renderer="renderLabel"
                code="id"></select-input>
</template>

<script>
import SelectInput from "@/components/controls/selectInput/SelectInput";

const formatPrintName = factory => {
  factory.printName = `${factory.name} (LFBIS: ${factory.businessIdentifier.lfbis})`
  return factory
}

export default {
  name: "select-factory",
  components: {
    SelectInput
  },
  props: {
    value: {
      type: String,
      default: undefined
    },
    factoryId: {
      type: String,
      default: null
    },
    firstAsDefault: {
      type: Boolean,
      default: false
    },
    passFactories: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      factories: []
    }
  },
  methods: {
    input(selectedFactory) {
      this.$emit('input', selectedFactory)
      this.$emit('change', this.factories.find(d => d.id === selectedFactory));
    },
    renderLabel(option) {
      if (option && option.factoryModel)
        return `${option.factoryModel.ringNr} ${option.factoryModel.label} (${option.printName})`;
    }
  },
  async mounted() {
    let factories = [];
    if (this.passFactories !== null) {
      factories = this.passFactories
    } else {
      if(this.factoryId === null) {
        factories = await this.$store.dispatch('pigSty/fetch');
      } else {
        factories = await this.$store.dispatch('pigSty/fetchByFactory', {factoryId: this.factoryId});
      }
    }
    this.factories = factories.map(formatPrintName);
    if(this.firstAsDefault && this.factories.length > 0) {
      this.$emit('input', this.factories[0].id);
      this.$emit('change', this.factories[0]);
    }
    this.$emit('factoriesLoaded', this.factories);
  },
  watch: {
    passFactories() {
      this.factories = this.passFactories.map(formatPrintName)
    }
  }
}
</script>

<style scoped>

</style>
